import React from 'react';

import useStyles from './styles';

const Arrow: React.VFC = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.thumbArrow}
      fill="none"
      height="8"
      viewBox="0 0 4 8"
      width="4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path clipRule="evenodd" d="M0 8L4 4L0 0L0 8Z" fillRule="evenodd" />
    </svg>
  );
};

/**
 * @internal
 */
const Thumb: React.VFC = (props: React.HTMLProps<HTMLElement>) => {
  return (
    <span {...props}>
      <Arrow />
      <Arrow />
    </span>
  );
};

/**
 * @internal
 */
export default Thumb;
